import { render, staticRenderFns } from "./Create-Update-Password.vue?vue&type=template&id=6bd799ac&scoped=true&"
import script from "./Create-Update-Password.vue?vue&type=script&lang=js&"
export * from "./Create-Update-Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd799ac",
  null
  
)

export default component.exports